(function () {
  angular.module("akitabox.asset.detail", [
    "ui.router",
    "akitabox.constants",
    "akitabox.core.router",
    "akitabox.core.services.asset",
    "akitabox.core.services.pinValue",
    "akitabox.core.services.recentActivity",
    "akitabox.ui.dialogs.message.create",
    "akitabox.core.toast",
  ]);
})();
